import { DatastoreInterface } from '@freelancer/datastore/core';
import { MembershipBadgeType } from '@freelancer/ui/badge';
import { generateAvatar } from '../users/users.mock';
import { UserInfo } from './user-info.model';
import { UserInfoCollection } from './user-info.types';

interface GenerateUserInfoOptions {
  readonly userId: number;
  readonly username?: string;
  readonly publicName?: string;
}

export async function createUserInfo(
  datastore: DatastoreInterface,
  options: GenerateUserInfoOptions,
) {
  const object = generateUserInfoObject(options);
  await datastore.createRawDocument<UserInfoCollection>('userInfo', object);
  return object;
}

function generateUserInfoObject({
  userId,
  username = 'testUsername',
  publicName = 'Test Name',
}: GenerateUserInfoOptions): UserInfo {
  return {
    id: userId.toString(),
    userId,
    username,
    publicName,
    isFreeTrialEligible: false,
    isPlusTrialEligible: false,
    isPremium: false,
    avatar: generateAvatar(userId),
    membership: 'plus',
    membershipBadge: MembershipBadgeType.MONTHLY_LEVEL_THREE,
    hideMembershipUpgradeButton: false,
    monthlyTrial: false,
    canSwitchToUsers: [],
    isNoCommissionEligibleReferrer: false,
    isCorporate: false,
  };
}
